import React, { Component } from 'react';
import Tab from '../../../common/tab';
import '../top-mover.scss';
import withTabAndRealTime from '../common/withTabAndRealtime';
import { indexMapFilter } from '../Const';
import { ComponentNameProvider } from '../../../common/ComponentNameContext';
import { Provider } from '../../../common/ComponentIdContext';
import AllExchanges from './AllExchanges';
import { connect } from 'react-redux';
import { applyFilter, subscribeRealtimeTickTopBreakout } from './reducer';
import ScrollComponent from './../../../common/ScrollComponent';
import { compose } from 'redux';
import PreRender from '../../../common/PreRender';
import ConstCommon from './../../../common/Const';
import { I18n } from 'react-redux-i18n';
import Export from './Export';
import DropDownRate from './DropDownRate';
import DropDownTimeRange from './DropDownTimeRange';
import TabTimer from '../../../common/tab-timer';

class TopBreakout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonClass: 'btn btn-cus-nomal bg-b-color-3 ml-10 apply-btn',
    };
    this.handleButtonPress = this.handleButtonPress.bind(this);
    this.handleButtonUp = this.handleButtonUp.bind(this);
  }

  filterApplyClick = () => {
    const { applyFilter, indexTab } = this.props;
    const filter = indexMapFilter[indexTab];

    applyFilter(filter);
  };

  handleButtonPress() {
    this.setState({
      buttonClass: 'btn active btn-cus-nomal bg-b-color-3 ml-10 apply-btn',
    });
  }

  handleButtonUp() {
    this.setState({
      buttonClass: 'btn btn-cus-nomal bg-b-color-3 ml-10 apply-btn',
    });
  }

  render() {
    const { indexTab, changeIndex, typeTab, changeType, id } = this.props;
    const filter = indexMapFilter[indexTab];

    return (
      <PreRender {...this.props}>
        <Provider value={id}>
          <ComponentNameProvider value={ConstCommon.listComponent.TopBreakout}>
            <ScrollComponent>
              <div
                className={`top-nav d-flex flex-column ${
                  typeTab === 5 ? '' : 'h-100'
                }`}
              >
                <div className={`px-20 pt-8 ${typeTab === 5 ? 'sticky' : ''}`}>
                  <Tab
                    currentTab={indexTab}
                    listTab="topVolume.tab"
                    changeTab={changeIndex}
                  />

                  <div className="d-flex flex-column">
                    <div className="w-100">
                      <div className="d-flex justify-content-between list-filter top-nav">
                        <TabTimer
                          currentTab={typeTab}
                          listTab="topVolume.tabDataChange.tabDataChangeTab"
                          changeTab={changeType}
                        />
                        <div style={{ paddingTop: 2, paddingLeft: 20 }}>
                          {typeTab !== 5 && (
                            <Export filter={filter} typeTab={typeTab} />
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="float-left">
                      <div className="list-filter mb-10 date-top-breakout">
                        <span className="label-span first mr-5">
                          {I18n.t('topBreakout.filterContent.part_1')}
                        </span>
                        <div className="line-drop">
                          <DropDownTimeRange comGroupCode={filter} />
                        </div>
                        <span className="label-span last ml-5">
                          {I18n.t('topBreakout.filterContent.part_2')}
                        </span>
                        <div className="line-drop">
                          <DropDownRate comGroupCode={filter} />
                        </div>
                        <span className="label-span ml-5 mr-5">
                          {I18n.t('topBreakout.filterContent.part_3')}
                        </span>
                        <div
                          onMouseDown={this.handleButtonPress}
                          onMouseLeave={this.handleButtonUp}
                          className={this.state.buttonClass}
                          onClick={this.filterApplyClick}
                        >
                          {I18n.t('topBreakout.filterContent.apply')}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="tab-content d-flex flex-fill flex-column">
                  <AllExchanges
                    key={indexTab}
                    typeTab={typeTab}
                    filter={filter}
                  />
                </div>
              </div>
            </ScrollComponent>
          </ComponentNameProvider>
        </Provider>
      </PreRender>
    );
  }
}

const mapDispatchToProps = {
  dispatchRealtime: subscribeRealtimeTickTopBreakout,
  applyFilter,
};

export default compose(
  connect(
    null,
    mapDispatchToProps,
  ),
  withTabAndRealTime(ConstCommon.listComponent.TopBreakout),
)(TopBreakout);
